import { TutorialStep } from '@hefe/models';
import { Avatar, Typography } from 'antd';
import { useMemo } from 'react';
import styles from './tutorial-step.module.scss';

interface TutorialStepComponentProps {
  step: TutorialStep;
  number: number;
}

export default function TutorialStepComponent(
  props: TutorialStepComponentProps
) {
  const { step } = props;

  const text = useMemo(() => {
    const locale = navigator.language.split('-')[0];
    return (step as any)[`text_${locale}`] ?? step.text_de;
  }, [step]);

  const title = useMemo(() => {
    const locale = navigator.language.split('-')[0];
    return (step as any)[`title_${locale}`] ?? step.title_de;
  }, [step]);

  return (
    <div className={styles['step']}>
      <Avatar size={64}>{props.number}</Avatar>
      <Typography.Title level={2} style={{ color: 'white' }}>
        {title}
      </Typography.Title>
      <Typography.Paragraph color="white" style={{ color: 'white' }}>
        {text}
      </Typography.Paragraph>
    </div>
  );
}
